import { render, staticRenderFns } from "./file-detail.vue?vue&type=template&id=23194ad0&scoped=true"
import script from "./file-detail.vue?vue&type=script&lang=js"
export * from "./file-detail.vue?vue&type=script&lang=js"
import style0 from "./file-detail.vue?vue&type=style&index=0&id=23194ad0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23194ad0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23194ad0')) {
      api.createRecord('23194ad0', component.options)
    } else {
      api.reload('23194ad0', component.options)
    }
    module.hot.accept("./file-detail.vue?vue&type=template&id=23194ad0&scoped=true", function () {
      api.rerender('23194ad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/file-detail.vue"
export default component.exports